import React, { FC } from 'react';

import { BackgroundBar, IndicatorBar } from './styles';

type Props = {
    color?: string;
};

const ActivityIndicator: FC<Props> = ({ color }) => (
    <BackgroundBar>
        <IndicatorBar $indicatorColor={color} />
    </BackgroundBar>
);

export default ActivityIndicator;
